// Helpers for media (image/video) entries stored on CRM line items and vehicles.
// Video entries may carry optional fields from the background transcoding worker:
//   media_type:'image'|'video', status:'transcoding'|'ready'|'failed',
//   entry_id, poster_url, small_url
// Image and legacy entries have a non-empty `url` and no `status` (treated as ready).

const VIDEO_EXT_RE = /\.(mp4|mov|webm|mkv|m4v)(?:$|\?)/i;

// True when an entry represents a video (by explicit media_type or url extension).
export const isVideoEntry = (img) =>
  img?.media_type === 'video' || VIDEO_EXT_RE.test(img?.url || '');

// True while a video is still being transcoded (url is empty until ready).
export const isTranscoding = (img) => img?.status === 'transcoding';

// True when transcoding failed.
export const isFailed = (img) => img?.status === 'failed';

// True when the entry has a real url that is safe to put into an <img>/<video> src.
export const isRenderableMedia = (img) =>
  Boolean(img?.url) && img?.status !== 'transcoding' && img?.status !== 'failed';

// True when any entry in the array is still transcoding.
export const hasTranscodingMedia = (images) =>
  Array.isArray(images) && images.some(isTranscoding);
